<template>
    <div class="mypage_common">
        <div class="common_head">
            <h5>1:1문의내역</h5>
            <p>고객님께서 문의하신 내용을 확인하실 수 있습니다.</p>
        </div>
        <div class="common_body">
            <ul class="txtList">
                <li>· 로그인 상태에서 문의하신 내역만 제공됩니다.</li>
                <li>· 전화상담이 필요하신 경우 <span>고객센터 02-000-0000</span>를 이용하시기 바랍니다.</li>
            </ul>
            <div class="check_area">
                <ul class="date_filter">
                    <li
                        v-for="date in dateCategories"
                        @click="selectDate(date.value)"
                    >
                        <a :class="{active: selectedDate === date.value}">{{ date.name }}</a>
                    </li>
                </ul>
                <div class="date_input">
                    <input type="date" v-model="startInput">
                    <span>~</span>
                    <input type="date" v-model="endInput">
                    <button type="button" @click="searchDate">조회</button>
                </div>
            </div>
            <div class="tbl_wrap">
                <table class="list">
                    <colgroup>
                        <col style="width: 10%;">
                        <col style="width: 45%;">
                        <col style="width: 15%;">
                        <col style="width: 15%;">
                        <col style="width: 15%;">
                    </colgroup>
                    <thead>
                        <tr>
                            <th>
                                <div class="chk_wrap">
                                    <input type="checkbox" id="chkAll" name="chkAll" @change="toggleAllCheck($event.target.checked)">
                                    <label for="chkAll" class="chk_btn">
                                    </label>
                                </div>
                            </th>
                            <th>제목</th>
                            <th>등록일</th>
                            <th>답변일</th>
                            <th>처리상태</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="inquiry in inquiryList">
                            <td>
                                <div class="chk_wrap">
                                    <input 
                                        type="checkbox" 
                                        id="chk01" 
                                        name="chk01"
                                        :value="inquiry.inquirySeq"
                                        v-model="selectedInquiries">
                                    <label for="chk01" class="chk_btn">
                                    </label>
                                </div>
                            </td>
                            <td>
                                <!-- <span class="type">[상품문의]</span> -->
                                {{ inquiry.questionTitle }}
                            </td>
                            <td>
                                {{ inquiry.createDate }}
                            </td>
                            <td>
                                {{ inquiry.answerDate }}
                            </td>
                            <td :class="{ing: inquiry.isAnswered === '접수중'}">
                                {{ inquiry.isAnswered }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="none_cont" v-if="inquiryList.length < 1">
                <p>고객님께서 문의하신 1:1 문의 내역이 없습니다.</p>
            </div>
            <CustomerServicePagination
                :totalPages = "totalPages()"
                :currentPage = currentPage
                @changePage = "changePage"
            />
            <div class="board_btn">
                <button type="button" class="btn_inquiryDel" @click="deleteInquiries">삭제</button>
                <button type="button" class="btn_inquiry" @click="toInquiry">1:1문의</button>
            </div>
        </div>
    </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import CustomerServicePagination from '@/components/common/CustomerServicePagination.vue';

const inquiryModule = 'inquiryModule'

export default {
  components: {
    CustomerServicePagination
  },

  data () {
    return {
      currentPage: 1,
      dateCategories: [
        { name: '오늘', value: 0 },
        { name: '10일', value: 10 },
        { name: '30일', value: 30 },
        { name: '60일', value: 60 },
        { name: '90일', value: 90 },
        { name: '120일', value: 120 },
      ],
      selectedDate: 0,
      startInput: '',
      startDate: '',
      endInput: '',
      endDate: '',
      selectedInquiries: []
    }
  },

  methods: {
    ...mapActions(inquiryModule, [
        'requestInquiryList',
        'requestDeleteInquiries'
    ]),

    selectDate(val) {
        this.selectedDate = val
    },

    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },

    async searchDate() {
        this.startDate = this.startInput
        this.endDate = this.endInput
        const {currentPage, startDate, endDate} = this
        await this.requestInquiryList({currentPage, startDate, endDate})
    },

    totalPages () {
      return Math.ceil(this.inquiryCount / 10);
    },

    async changePage (page) {
      this.currentPage = page
      const {currentPage, startDate, endDate} = this
      await this.requestInquiryList({currentPage, startDate, endDate})
    },

    async deleteInquiries() {
        if (this.selectedInquiries.length === 0) {
            this.$openModal('alertModal', {
                message: '선택된 문의가 없습니다'
            })
            return;
        }

        const {currentPage, startDate, endDate} = this
        const fetchInquiries = async (page = currentPage, start = startDate, end = endDate, isReset = false) => {
            const params = { currentPage: page, startDate: start, endDate: end };
            await this.requestInquiryList(params);
            console.log('params: ' + params.currentPage + ', ' + params.startDate + ', ' + params.endDate)
            if (isReset) {
                console.log('isReset')
                this.startDate = this.formatDate(new Date());
                this.endDate = this.formatDate(new Date());
                this.startInput = this.startDate
                this.endInput = this.endDate
                this.selectedDate = 0
            }
        };

        await this.requestDeleteInquiries(this.selectedInquiries);
        this.selectedInquiries = [];

        await fetchInquiries(currentPage);

        if (this.inquiryList.length === 0 && this.currentPage > 1) {
            console.log('first')
            this.currentPage -= 1;
            await fetchInquiries(this.currentPage);
        }

        if (this.inquiryList.length === 0 && this.currentPage === 1) {
            console.log('sec')
            this.currentPage = 1;
            await fetchInquiries(1, this.formatDate(new Date()), this.formatDate(new Date()), true);
        }
    },

    toInquiry() {
        this.$router.push({name: 'InquiryCreatePage'})
    },

    toggleAllCheck(isChecked) {
      if (isChecked) {
        this.selectedInquiries = []
        for (const inquiry of this.inquiryList) {
          this.selectedInquiries.push(inquiry.inquirySeq)
        }
      } else {
        this.selectedInquiries = []
      }
    },
  },

  computed: {
    ...mapState(inquiryModule, [
        'inquiryList',
        'inquiryCount'
    ])
  },

  watch: {
    selectedDate: {
        handler(newVal) {
            const today = new Date();
            this.endInput = this.formatDate(today);
            const pastDate = new Date();
            pastDate.setDate(today.getDate() - newVal);
            this.startInput = this.formatDate(pastDate);
        },
        immediate: true
    }
  },

  async mounted() {
    this.startDate = this.startInput
    this.endDate = this.endInput
    const {currentPage, startDate, endDate} = this
    await this.requestInquiryList({currentPage, startDate, endDate})
  }
}
</script>